import { Images } from "assets";
import { Svg } from "assets/svg";
import React, { useRef, forwardRef, useState, useMemo, useCallback, useEffect } from "react";
import {
    TouchableOpacity,
    Image,
    StyleSheet,
    Pressable,
    View,
    Text,
    useWindowDimensions,
    ScrollView,
    TextInput,
} from "react-native";
import { fp, hp, spH, spV, wp } from "utils/normalizeV2";
import BottomSheetModal from "components/BottomSheetModal";
import VText from "components/VText";
import ExploreTheLookView from "./exploreTheLookView";
import Buttons from "components/Buttons";
import { Colors } from "colors";
import SelectProductCardComponent from "./selectProductCardComponent";
import CustomizeLook from "./customizeLookCardComponent";
import SearchProducts from "./searchProductsComponent";
import SelectSizeView from "./selectSizeView";
import ReplaceSimilarProductsModal from "./replaceSimilarProduct";
import SizeModal from "./sizeModal";
import { useDispatch } from "react-redux";
import { addToCart, setCart } from "appRedux/reducers/cartSlice";
import SuccessToster from "./successToster";
import { getFavProducts } from "appRedux/reducers/productSlice";


// 1 - Explore the Look
// 2 - Select Products
// 3 - Select Size
// 4 - Customize the Look
// 5 - Add Products
// 6 - Replace Product

const ExploreLookCommonModal = forwardRef((props, ref) => {
    const [searchProduct, setSearchProduct] = useState("");
    const [currentPageId, setCurrentPageId] = useState(1);
    const [previousPageId, setPreviousPageId] = useState(1);
    const [outfitData, setOutfitData] = useState(null);
    const [isAddToCartEnabled, setIsAddToCartEnabled] = useState(false);
    const [newSelectedProducts, setNewSelectedProducts] = useState([]);
    const [cartData, setCartData] = useState([]);
    const { height, width } = useWindowDimensions();
    const [selectedProducts, setSelectedProducts] = useState([]);
    const _bottomSheetRef = useRef();
    const _sizeGuideRef = useRef();
    const _successTosterRef = useRef();
    const _scrollViewRef = useRef();
    const _replaceProductRef = useRef();
    const [replaceProduct, setReplaceProduct] = useState(null);
    const [replacedProduct, setReplacedProduct] = useState(null);

    const dispatch = useDispatch();
    React.useImperativeHandle(ref, () => ({ show, hide }), []);
    const [isLoading, setIsLoading] = useState(false);


    const show = (item) => {
        setOutfitData(item);
        _bottomSheetRef?.current?.show();
    };

    useEffect(() => {
        dispatch(getFavProducts());
    }, []);


    const hide = () => {
        _bottomSheetRef?.current?.hide();
        setTimeout(() => {
            clearState();
        }, 300);
    };

    const clearState = () => {
        setCurrentPageId(1);
        setPreviousPageId(1);
        setOutfitData(null);
        setSelectedProducts([]);
        setCartData([]);
    };

    const searchProductInput = () => {
        return (
            <View style={{flex: 1, alignItems: "center", justifyContent: "center", flexDirection: "row"}}>
                <View style={{width: wp(550), height: wp(40),backgroundColor: "#F7F7F7", flexDirection: "row", alignItems: "center", justifyContent: "center"}}>
                    <Image source={Svg.searchIcon} style={{width: wp(15), height: wp(15),}} />
                <TextInput
                    placeholder="Search products to add"
                    style={{
                        width:"95%",
                        padding:wp(10),
                        fontSize: fp(14),
                        fontFamily: "JosefinSans",
                        color: "#21242799",
                        border: "none",
                    }}
                    value={searchProduct}
                    onChangeText={setSearchProduct}
                />
               
                </View>
                
                <TouchableOpacity style={{marginLeft: wp(10),opacity: newSelectedProducts.length > 0 ? 1 : 0}} onPress={() => setNewSelectedProducts([])}>
                    <VText>Unselect</VText>
                </TouchableOpacity>
            </View>
        )
    }

    const handleSearch = (text) => {
        setSearchProduct(text);
    }

    const showReplaceProduct = (product) => {
        setReplaceProduct(product);
        _replaceProductRef?.current?.show();
        setCurrentPageId(6);
    }

    const renderPage = () => {
        switch (currentPageId) {
            case 1:
                return <ExploreTheLookView setCurrentPageId={setCurrentPageId} outfitData={outfitData} />;
            case 2:
                return (
                    <SelectProductCardComponent
                        selectedProducts={selectedProducts}
                        setSelectedProducts={setSelectedProducts}
                        outfitData={outfitData}
                    />
                );
            case 3:
                return (
                    <SelectSizeView
                        setIsAddToCartEnabled={setIsAddToCartEnabled}
                        setCartData={setCartData}
                        cartData={cartData}
                        _sizeGuideRef={_sizeGuideRef}
                        outfitData={
                            (previousPageId === 2 || previousPageId === 4)
                                ? selectedProducts.filter((item) => item?.productSizes?.length > 0)
                                : outfitData.filter((item) => item?.productSizes?.length > 0)
                        }
                    />
                );
            case 4:
                return <CustomizeLook outfitData={outfitData} selectedProducts={selectedProducts} setSelectedProducts={setSelectedProducts} newSelectedProducts={newSelectedProducts} setNewSelectedProducts={setNewSelectedProducts} setReplaceProduct={setReplaceProduct} showSimilarProducts={showReplaceProduct} />;
            case 5:
                return <SearchProducts searchKey={searchProduct} newSelectedProducts={newSelectedProducts} setNewSelectedProducts={setNewSelectedProducts} />;
            case 6:
                return <ReplaceSimilarProductsModal ref={_replaceProductRef} product={replaceProduct} replaceProduct={replaceProduct}  setReplaceProduct={setReplaceProduct} replacedProduct={replacedProduct} setReplacedProduct={setReplacedProduct} />;  
                
        }
    };

    const footerButtonText = useMemo(() => {
        switch (currentPageId) {
            case 1:
                return "Select Size";
            case 2:
                return "Shop Selected";
            case 3:
                return "Add to Cart";
            case 4:
                return "Select Size";
            case 5:
                return "Add Products";
            case 6:
                return "Save Changes";
        }
    }, [currentPageId]);

    const handleFooterButtonPress = () => {
        _scrollViewRef?.current?.scrollTo({ y: 0, animated: true });
        switch (currentPageId) {
            case 1:
                setPreviousPageId(currentPageId);
                setCurrentPageId(3);
                break;
            case 2:
                setPreviousPageId(currentPageId);
                setCurrentPageId(3);
                break;
            case 3:
                setIsLoading(true);
                const promises = cartData.map((product) => {
                    return dispatch(
                        addToCart({
                            productId: product.productId,
                            qty: 1,
                            size: product.size,
                        })
                    );
                });

                Promise.all(promises)
                    .then((res) => {
                        res.forEach((response) => {
                            if ([200].includes(response?.payload?.status) && response?.payload?.data?.cart) {
                                dispatch(setCart(response?.payload?.data));
                            }
                        });
                        setIsLoading(false);
                        _successTosterRef?.current?.show();
                        setTimeout(() => {
                            _successTosterRef?.current?.hide();
                            hide(() => {
                                _bottomSheetRef?.current?.hide();
                                
                                clearState();
                                // hide();
                            });
                        }, 2000);
                       
                    })
                    .catch(() => {
                        setIsLoading(false);
                    });
                break;
            case 4:
                setPreviousPageId(currentPageId);
                setCurrentPageId(3);
            break;
            case 5:
                setPreviousPageId(currentPageId);
                setCurrentPageId(4);

                let newallProducts = [...selectedProducts, ...newSelectedProducts.map((item) => ({...item, id: item.productId}))];
                setSelectedProducts(newallProducts);
                setNewSelectedProducts([]);
            break;
            case 6:
                setPreviousPageId(currentPageId);
                setCurrentPageId(4);
                const updatedSelectedProducts = selectedProducts.map(item => 
                    item.id === replaceProduct.id ? replacedProduct : item
                );
                setSelectedProducts(updatedSelectedProducts);
            break;
        }
    };

 

    const onPressBackButton = useCallback(() => {
        switch (currentPageId) {
            case 2:
                setCurrentPageId(1);
                setSelectedProducts(outfitData);
                break;
            case 3:
                if (previousPageId === 2) {
                    setCurrentPageId(2);
                } else {
                    setCurrentPageId(previousPageId);
                }
                break;
            case 6:
                setCurrentPageId(4);
            break;
            case 4:
                setCurrentPageId(1);
            break;
            case 5:
                setCurrentPageId(4);
            break;
        }
    }, [currentPageId, previousPageId]);

    const headerTitle = useMemo(() => {
        switch (currentPageId) {
            case 1:
                return "Explore the Look";
            case 2:
                return "Select Products";
            case 3:
                return "Select Size";
            case 4:
                return "Customize the Look";
            case 5:
                return "Add Products";
            case 6:
                return "View Similar";
        }
    }, [currentPageId]);

    return (
        <BottomSheetModal
            MAX_HEIGHT_PERC={1}
            START_PERC={1}
            ref={_bottomSheetRef}
            hideLine
            containerStyle={{
                backgroundColor: "transparent",
                zIndex: 200,
            }}
        >
            <TouchableOpacity
                style={{
                    backgroundColor: "transparent",
                    width,
                    height,
                    alignItems: "center",
                    justifyContent: "center",
                    overflow: "hidden",
                    zIndex: 200,
                    cursor: "auto",
                }}
                activeOpacity={1}
                onPress={() => hide()}
            >
                <Pressable style={styles.modalContainer}>
                    <View style={styles.headerContainer}>


                        <TouchableOpacity style={[styles.backButton, currentPageId === 1 ? { opacity: 0 } : { opacity: 1 }]} onPress={onPressBackButton}>
                            <Image source={Images.leftArrow} style={styles.closeIcon} />
                        </TouchableOpacity>
                        {(currentPageId === 5 && searchProductInput()) || <VText style={styles.title}>{headerTitle}</VText>}

                    
                        <TouchableOpacity style={styles.closeButton} onPress={hide}>
                            <Image source={Svg.closeIcon} style={styles.closeIcon} />
                        </TouchableOpacity>
                    </View>
                    <ScrollView
                        ref={_scrollViewRef}
                        style={{ flex: 1, margin: spH(10) }}
                        contentContainerStyle={{ width: wp(750), paddingBottom: spH(80) }}
                    >
                        {renderPage()}
                    </ScrollView>
                    <View style={styles.stickyFooter}>
                        <Buttons
                            loading={isLoading}
                            disabled={(currentPageId === 3 && !isAddToCartEnabled) || (currentPageId === 5 && newSelectedProducts.length === 0)}
                            containerStyle={[
                                styles.btnStyle,
                                currentPageId === 3 && !isAddToCartEnabled && { backgroundColor: Colors.black60 },
                                currentPageId === 5 && newSelectedProducts.length === 0 && { backgroundColor: Colors.black60 },
                            ]}
                            textColor={Colors.white}
                            text={footerButtonText}
                            onPress={handleFooterButtonPress}
                        />

                      {currentPageId === 4 && (
                        <TouchableOpacity style={styles.addProductButton} onPress={() => setCurrentPageId(5)}>
                            <Image source={Images.addIcon} style={{width: wp(50), height: wp(50),}}  />
                        </TouchableOpacity>
                      )}
                    </View>
                </Pressable>
            </TouchableOpacity>
            <SizeModal ref={_sizeGuideRef} setCartData={setCartData} cartData={cartData} />
            <SuccessToster ref={_successTosterRef} />

        </BottomSheetModal>
    );
});




const styles = StyleSheet.create({
    modalContainer: {
        backgroundColor: "white",
        borderRadius: fp(10),
        // width: wp(1100),
        maxHeight: hp(700),
        alignItems: "center",
    },
    headerContainer: {
        width: "100%",
        padding: spV(20),
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "center",
    },
    backButton: {
        width: wp(30),
        height: wp(30),
    },
    closeButton: {
        width: wp(30),
        height: wp(30),
    },
    closeIcon: {
        width: wp(25),
        height: wp(25),
    },
    title: {
        fontSize: fp(28),
        fontWeight: "500",
        fontFamily: "Libre-Bold",
    },
    buttonContainer: {
        width: "100%",
        flexDirection: "row",
        justifyContent: "space-between",
        marginTop: spV(20),
    },
    button: {
        backgroundColor: "#f5f5f5",
        padding: spV(12),
        borderRadius: fp(4),
        alignItems: "center",
    },
    buttonText: {
        fontSize: fp(12),
        fontWeight: "500",
    },
    stickyFooter: {
        position: "absolute",
        bottom: 0,
        left: 0,
        right: 0,
        backgroundColor: "white",
        paddingVertical: spV(13),
        paddingHorizontal: spH(20),
        borderTopWidth: 1,
        borderTopColor: "#f0f0f0",
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "center",
        shadowColor: "#000",
        shadowOffset: {
            width: 0,
            height: -2,
        },
        shadowOpacity: 0.1,
        shadowRadius: 3,
        elevation: 5,
    },
    btnStyle: {
        // backgroundColor: Colors.black60,
        width: "100%",
        },
    addProductButton: {
        width: wp(40),
        height: wp(40),
        alignItems: "center",
        position: "absolute",
        bottom: hp(100),
        right: wp(24),
    },

});

ExploreLookCommonModal.displayName = "ExploreLookCommonModal";
export default ExploreLookCommonModal;
